<template>
    <div class="row inline-details">
        <div class="col-6 loading-info-details-left">
            <p class="destination"><strong>{{$t('shopfloor.order.destination')}} </strong></p>
            <p class="details-text-left">{{order.receiver.address}}<br>{{order.receiver.zipcode}} {{order.receiver.city}}<br>{{order.receiver.country}}</p>
        </div>
        <div class="col-6 loading-info-details-right">
            <p class="client"><strong>{{$t('shopfloor.order.client')}} </strong></p>
            <p class="details-text-right">{{order.sender.name}}<br>{{order.sender.zipcode}} {{order.sender.city}}<br>{{order.sender.country}}</p>
        </div>
      <div v-if="order.loadingRemark" class="col-12 loading-remark-details-left">
        <p class="destination"><strong>Loading remark</strong></p>
        <p class="details-text-left">{{order.loadingRemark}}</p> </div>
    </div>


</template>

<script>
    export default {
        name: 'order-destination',
        props: ['order'],
        data() {
            return {
                recentlyAdded: true
            }
        },
        methods: {
            formatTime(time) {
                return moment(time.seconds * 1000).format('HH:mm')
            },

        },
    }
</script>